import { useContext } from "react";
import { AskServiceContext } from "../providers/AskServiceProvider";

export default function useAskService() {
  const askServiceHelpers = useContext(AskServiceContext);

  return askServiceHelpers;
}
